import React from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { InlinePopover } from './InlinePopover';
import { StatusBadge } from './StatusBadge';
import { statusOptions } from '../../data/conditions';
import type { ConditionStatus } from '../../types/conditions';
interface StatusSelectProps {
  value: ConditionStatus;
  onChange: (status: ConditionStatus) => void;
  conditionName: string;
}
export function StatusSelect({
  value,
  onChange,
  conditionName
}: StatusSelectProps) {
  return <InlinePopover ariaLabel={`Status for ${conditionName}`} triggerClassName="group inline-flex items-center gap-1 p-0.5 hover:bg-slate-100" trigger={<>
          <StatusBadge status={value} data-id="element-298" data-mp="kkd5omqitzu4" />
          <ChevronDownIcon className="h-3.5 w-3.5 text-slate-400 group-hover:text-slate-600" aria-hidden="true" data-id="element-299" data-mp="kjbnzzf02f3f" />
        </>} data-id="element-297" data-mp="au1ssaov0gb3">
      {close => <ul role="listbox" aria-label="Status" className="w-52 rounded-md border border-slate-200 bg-white py-1.5 shadow-lg" data-id="element-300" data-mp="tl1khjnqo482">
          {statusOptions.map(opt => {
        const selected = opt.value === value;
        return <li key={opt.value} data-id="element-301" data-mp="mjbo0ea5o13f">
                <button type="button" role="option" aria-selected={selected} onClick={() => {
            onChange(opt.value);
            close();
          }} className={`relative flex w-full items-center justify-center px-8 py-2 text-xs font-bold tracking-wider transition-colors hover:bg-slate-50 focus:bg-slate-50 focus:outline-none ${selected ? 'text-brand-dark' : 'text-slate-700'}`} data-id="element-302" data-mp="mijtz7w7ibf9">
                  {selected && <CheckIcon className="absolute left-4 h-4 w-4 text-brand" aria-hidden="true" data-id="element-303" data-mp="1xyrvr73tdipv" />}
                  {opt.label}
                </button>
              </li>;
      })}
        </ul>}
    </InlinePopover>;
}